export default __webpack_public_path__ + "static/media/mod02.f1f6d998.svg";